import React, { FormEvent, useCallback } from "react";
import { Form } from "../../../packages/ui/form/Form.js";
import { TemplateInput } from "./TemplateInput.js";
import { Buttons } from "../../../packages/ui/form/Buttons.js";
import { Button } from "../../../packages/ui/button/Button.js";
import { FormRow } from "../../../packages/ui/form/FormRow.js";
import { FilesInput } from "../../../packages/ui/form/FilesInput.js";
import { useTemplate } from "./TemplateProvider.js";

/**
 * Renders form for the selected template input variables.
 */
export const TemplateForm = () => {
  const { template, submitEntry, setFiles } = useTemplate();

  const handleSubmit = useCallback(
    async (event: FormEvent) => {
      event.preventDefault();
      submitEntry();
    },
    [submitEntry]
  );

  return (
    <>
      <div className="template-form">
        <Form onSubmit={handleSubmit}>
          {template.variables.map((variable) => (
            <TemplateInput key={variable.name} variable={variable} />
          ))}
          <FormRow columns={1}>
            <FilesInput
              label="Upload files"
              accept=".png,.jpg,.jpeg,.pdf,.odf,.doc,.docx,.zip"
              onChange={setFiles}
            />
          </FormRow>
          <FormRow columns={1}>
            <Buttons>
              <Button type="submit">Generate entry and save</Button>
            </Buttons>
          </FormRow>
        </Form>
      </div>
    </>
  );
};
